import { floor, max } from "./math/Math"

export default function toFloorMin1(value: number | null | undefined): number {
  return max(1, floor(value as number))
}
